module.exports = __webpack_public_path__ + "img/id-lqtajwid-2.5ff7d458.webp";